module.exports = __webpack_public_path__ + "static/media/2-2.6957bb01.png";